var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"p-t-10 m-b-10"},[_c('strong',[_vm._v("费用汇总")])]),_c('i-table',{attrs:{"stripe":"","data":_vm.products,"columns":_vm.productColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }